






























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

interface Validator {
  hasError: boolean;
  message: string;
}

@Component
export default class AddressInput extends Vue {
  @Prop() value!: { country?: number; province?: number; district?: number };
  @Prop() outlined!: boolean;
  @Prop() bgColor!: string;

  @Prop({ default: () => ({ country: {}, province: {}, district: {} }) })
  validators?: {
    country: Validator;
    province: Validator;
    district: Validator;
  };

  $refs!: Vue['$refs'] & {
    provinceInput: any;
    districtInput: any;
  };

  get country() {
    return this.value.country;
  }

  set country(value) {
    this.$emit('input', {
      ...this.value,
      country: value,
      province: undefined,
      district: undefined,
    });
  }

  get province() {
    return this.value.province;
  }

  set province(value) {
    this.$emit('input', {
      ...this.value,
      province: value,
      district: undefined,
    });
  }

  get district() {
    return this.value.district;
  }

  set district(value) {
    this.$emit('input', { ...this.value, district: value });
  }

  get provinceQuery() {
    return this.country ? { params: { id: this.country || '0' } } : false;
  }

  get districtQuery() {
    return this.province ? { params: { id: this.province || '0' } } : false;
  }

  @Watch('value.country')
  onCountryChange() {
    this.$nextTick(() => this.$refs.provinceInput.initialize());
  }

  @Watch('value.province')
  onProvinceChange() {
    this.$nextTick(() => this.$refs.districtInput.initialize());
  }
}
